// Module
var code = "<div> <select class=\"form-control input-sm\" ng-model=\"vm.model\" name=\"{{vm.name}}\" ng-options=\"p.key as p.value | translate for p in vm.valueTypes[vm.strategy]\" ng-required=\"vm.isRequired\"></select> </div>";
// Exports
module.exports = code;